import { Link } from 'react-router-dom';

const CITIES = [
  { city: 'Salt Lake City', service: 'Roof Repair & Replacement', href: '/locations/salt-lake-city' },
  { city: 'West Valley City', service: 'Residential Roofing', href: '/locations/salt-lake-city' },
  { city: 'Provo', service: 'Roof Replacement', href: '/locations/salt-lake-city' },
  { city: 'Ogden', service: 'Commercial Roofing', href: '/locations/salt-lake-city' },
  { city: 'Sandy', service: 'Storm Damage', href: '/locations/salt-lake-city' },
  { city: 'South Jordan', service: 'Roofing Services', href: '/locations/salt-lake-city' },
  { city: 'West Jordan', service: 'Roof Repair', href: '/locations/salt-lake-city' },
  { city: 'Orem', service: 'Roof Replacement', href: '/locations/salt-lake-city' },
  { city: 'Draper', service: 'Premium Roofing', href: '/locations/salt-lake-city' },
  { city: 'Murray', service: 'Roofing Services', href: '/locations/salt-lake-city' },
  { city: 'Taylorsville', service: 'Residential Roofing', href: '/locations/salt-lake-city' },
  { city: 'Millcreek', service: 'Roof Repair', href: '/locations/salt-lake-city' },
];

export default function ServiceAreasSection() {
  return (
    <section id="service-areas" className="bg-charcoal">
      {/* Top Content */}
      <div className="py-20 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
          {/* Left: Heading + cities */}
          <div className="lg:col-span-2">
            <div className="w-16 h-1 bg-brand-orange rounded-full mb-6"></div>
            <h2 className="font-heading font-900 text-white text-5xl md:text-6xl uppercase tracking-tight leading-none mb-4">
              Proudly Serving<br />
              <span className="text-brand-orange">Utah Communities</span>
            </h2>
            <p className="font-body text-white/60 text-base leading-relaxed mb-8">
              Looking for roofing near you? Our team responds fast to homes and businesses across Northern Utah — local expertise, local results.
            </p>
            <Link
              to="/locations/salt-lake-city"
              className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orange-dark text-white font-heading font-700 text-sm uppercase tracking-widest px-7 py-3.5 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-map-pin-2-fill"></i>
              View Salt Lake City
            </Link>
          </div>

          {/* Right: City Grid */}
          <div className="lg:col-span-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {CITIES.map((item) => (
                <Link
                  key={item.city}
                  to={item.href}
                  className="flex items-center gap-3 bg-charcoal-light hover:bg-charcoal-light/80 rounded-lg px-5 py-3.5 group transition-colors cursor-pointer"
                >
                  <i className="ri-map-pin-2-fill text-brand-orange text-lg flex-shrink-0"></i>
                  <div>
                    <p className="font-heading font-800 text-white text-sm uppercase tracking-wide group-hover:text-brand-orange transition-colors">
                      {item.city}
                    </p>
                    <p className="font-body text-white/40 text-xs">{item.service}</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-white/20 text-lg ml-auto group-hover:text-brand-orange/60 transition-colors"></i>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Full-Width Map */}
      <div className="w-full border-t border-white/10">
        <iframe
          title="IWC Roofing Utah Service Area"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d192696.7905038449!2d-112.10124!3d40.6500!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87523d9488d131ed%3A0x5b53b7a0484d31ca!2sSalt%20Lake%20City%2C%20UT!5e0!3m2!1sen!2sus!4v1700000000000"
          width="100%"
          height="420"
          style={{ border: 0, display: 'block' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}
